// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/core/component/stake/v1/stake.proto (package penumbra.core.component.stake.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { ConsensusKey, GovernanceKey, IdentityKey } from "../../../keys/v1/keys_pb.js";
import { Amount } from "../../../num/v1/num_pb.js";
import { Epoch } from "../../sct/v1/sct_pb.js";
import { BalanceCommitment } from "../../../asset/v1/asset_pb.js";
/**
 * A Penumbra ZK undelegate claim proof.
 *
 * @generated from message penumbra.core.component.stake.v1.ZKUndelegateClaimProof
 */
export class ZKUndelegateClaimProof extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.ZKUndelegateClaimProof";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new ZKUndelegateClaimProof().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ZKUndelegateClaimProof().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ZKUndelegateClaimProof().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ZKUndelegateClaimProof, a, b);
    }
}
/**
 * Describes a validator's configuration data.
 *
 * @generated from message penumbra.core.component.stake.v1.Validator
 */
export class Validator extends Message {
    /**
     * The validator's identity verification key.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 1;
     */
    identityKey;
    /**
     * The validator's consensus pubkey for use in Tendermint (Ed25519).
     *
     * @generated from field: bytes consensus_key = 2;
     */
    consensusKey = new Uint8Array(0);
    /**
     * The validator's (human-readable) name.
     *
     * @generated from field: string name = 3;
     */
    name = "";
    /**
     * The validator's website.
     *
     * @generated from field: string website = 4;
     */
    website = "";
    /**
     * The validator's description.
     *
     * @generated from field: string description = 5;
     */
    description = "";
    /**
     * Whether the validator is enabled or not.
     *
     * Disabled validators cannot be delegated to, and immediately begin unbonding.
     *
     * @generated from field: bool enabled = 8;
     */
    enabled = false;
    /**
     * A list of funding streams describing the validator's commission.
     *
     * @generated from field: repeated penumbra.core.component.stake.v1.FundingStream funding_streams = 6;
     */
    fundingStreams = [];
    /**
     * The sequence number determines which validator data takes priority, and
     * prevents replay attacks.  The chain only accepts new validator definitions
     * with increasing sequence numbers.
     *
     * @generated from field: uint32 sequence_number = 7;
     */
    sequenceNumber = 0;
    /**
     * The validator's governance key.
     *
     * @generated from field: penumbra.core.keys.v1.GovernanceKey governance_key = 9;
     */
    governanceKey;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.Validator";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
        { no: 2, name: "consensus_key", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 4, name: "website", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 8, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 6, name: "funding_streams", kind: "message", T: FundingStream, repeated: true },
        { no: 7, name: "sequence_number", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
        { no: 9, name: "governance_key", kind: "message", T: GovernanceKey },
    ]);
    static fromBinary(bytes, options) {
        return new Validator().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Validator().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Validator().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Validator, a, b);
    }
}
/**
 * For storing the list of keys of known validators.
 *
 * @generated from message penumbra.core.component.stake.v1.ValidatorList
 */
export class ValidatorList extends Message {
    /**
     * @generated from field: repeated penumbra.core.keys.v1.IdentityKey validator_keys = 1;
     */
    validatorKeys = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.ValidatorList";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator_keys", kind: "message", T: IdentityKey, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new ValidatorList().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatorList().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatorList().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatorList, a, b);
    }
}
/**
 * A portion of a validator's commission.
 *
 * @generated from message penumbra.core.component.stake.v1.FundingStream
 */
export class FundingStream extends Message {
    /**
     * The recipient of the funding stream.
     *
     * @generated from oneof penumbra.core.component.stake.v1.FundingStream.recipient
     */
    recipient = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.FundingStream";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "to_address", kind: "message", T: FundingStream_ToAddress, oneof: "recipient" },
        { no: 2, name: "to_community_pool", kind: "message", T: FundingStream_ToCommunityPool, oneof: "recipient" },
    ]);
    static fromBinary(bytes, options) {
        return new FundingStream().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FundingStream().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FundingStream().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FundingStream, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.FundingStream.ToAddress
 */
export class FundingStream_ToAddress extends Message {
    /**
     * The destination address for the funding stream.
     *
     * @generated from field: string address = 1;
     */
    address = "";
    /**
     * The portion of the staking reward for the entire delegation pool
     * allocated to this funding stream, specified in basis points.
     *
     * @generated from field: uint32 rate_bps = 2;
     */
    rateBps = 0;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.FundingStream.ToAddress";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "rate_bps", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    ]);
    static fromBinary(bytes, options) {
        return new FundingStream_ToAddress().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FundingStream_ToAddress().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FundingStream_ToAddress().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FundingStream_ToAddress, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.FundingStream.ToCommunityPool
 */
export class FundingStream_ToCommunityPool extends Message {
    /**
     * The portion of the staking reward for the entire delegation pool
     * allocated to this funding stream, specified in basis points.
     *
     * @generated from field: uint32 rate_bps = 2;
     */
    rateBps = 0;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.FundingStream.ToCommunityPool";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "rate_bps", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    ]);
    static fromBinary(bytes, options) {
        return new FundingStream_ToCommunityPool().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FundingStream_ToCommunityPool().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FundingStream_ToCommunityPool().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FundingStream_ToCommunityPool, a, b);
    }
}
/**
 * Describes the reward and exchange rates and voting power for a validator in some epoch.
 *
 * @generated from message penumbra.core.component.stake.v1.RateData
 */
export class RateData extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 1;
     */
    identityKey;
    /**
     * @generated from field: uint64 epoch_index = 2 [deprecated = true];
     * @deprecated
     */
    epochIndex = protoInt64.zero;
    /**
     * @generated from field: penumbra.core.num.v1.Amount validator_reward_rate = 4;
     */
    validatorRewardRate;
    /**
     * The validator exchange rate between delegation tokens and staking tokens.
     * The rate is expressed in fixed-point representation with a scaling factor
     * of 10^8. For example, a decimal rate of `1.234` will be represented as
     * `123400000`
     *
     * @generated from field: penumbra.core.num.v1.Amount validator_exchange_rate = 5;
     */
    validatorExchangeRate;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.RateData";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
        { no: 2, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "validator_reward_rate", kind: "message", T: Amount },
        { no: 5, name: "validator_exchange_rate", kind: "message", T: Amount },
    ]);
    static fromBinary(bytes, options) {
        return new RateData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RateData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RateData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RateData, a, b);
    }
}
/**
 * Describes the base reward and exchange rates in some epoch.
 *
 * @generated from message penumbra.core.component.stake.v1.BaseRateData
 */
export class BaseRateData extends Message {
    /**
     * @generated from field: uint64 epoch_index = 1;
     */
    epochIndex = protoInt64.zero;
    /**
     * @generated from field: penumbra.core.num.v1.Amount base_reward_rate = 2;
     */
    baseRewardRate;
    /**
     * @generated from field: penumbra.core.num.v1.Amount base_exchange_rate = 3;
     */
    baseExchangeRate;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.BaseRateData";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "base_reward_rate", kind: "message", T: Amount },
        { no: 3, name: "base_exchange_rate", kind: "message", T: Amount },
    ]);
    static fromBinary(bytes, options) {
        return new BaseRateData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BaseRateData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BaseRateData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BaseRateData, a, b);
    }
}
/**
 * Describes the current state of a validator on-chain
 *
 * @generated from message penumbra.core.component.stake.v1.ValidatorStatus
 */
export class ValidatorStatus extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 1;
     */
    identityKey;
    /**
     * @generated from field: penumbra.core.component.stake.v1.ValidatorState state = 2;
     */
    state;
    /**
     * @generated from field: penumbra.core.num.v1.Amount voting_power = 3;
     */
    votingPower;
    /**
     * @generated from field: penumbra.core.component.stake.v1.BondingState bonding_state = 4;
     */
    bondingState;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.ValidatorStatus";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
        { no: 2, name: "state", kind: "message", T: ValidatorState },
        { no: 3, name: "voting_power", kind: "message", T: Amount },
        { no: 4, name: "bonding_state", kind: "message", T: BondingState },
    ]);
    static fromBinary(bytes, options) {
        return new ValidatorStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatorStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatorStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatorStatus, a, b);
    }
}
/**
 * Describes the unbonding state of a validator's stake pool.
 *
 * @generated from message penumbra.core.component.stake.v1.BondingState
 */
export class BondingState extends Message {
    /**
     * @generated from field: penumbra.core.component.stake.v1.BondingState.BondingStateEnum state = 1;
     */
    state = BondingState_BondingStateEnum.UNSPECIFIED;
    /**
     * @generated from field: uint64 unbonds_at_epoch = 2 [deprecated = true];
     * @deprecated
     */
    unbondsAtEpoch = protoInt64.zero;
    /**
     * @generated from field: uint64 unbonds_at_height = 3;
     */
    unbondsAtHeight = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.BondingState";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "state", kind: "enum", T: proto3.getEnumType(BondingState_BondingStateEnum) },
        { no: 2, name: "unbonds_at_epoch", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "unbonds_at_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new BondingState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BondingState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BondingState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BondingState, a, b);
    }
}
/**
 * @generated from enum penumbra.core.component.stake.v1.BondingState.BondingStateEnum
 */
export var BondingState_BondingStateEnum;
(function (BondingState_BondingStateEnum) {
    /**
     * @generated from enum value: BONDING_STATE_ENUM_UNSPECIFIED = 0;
     */
    BondingState_BondingStateEnum[BondingState_BondingStateEnum["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: BONDING_STATE_ENUM_BONDED = 1;
     */
    BondingState_BondingStateEnum[BondingState_BondingStateEnum["BONDED"] = 1] = "BONDED";
    /**
     * @generated from enum value: BONDING_STATE_ENUM_UNBONDING = 2;
     */
    BondingState_BondingStateEnum[BondingState_BondingStateEnum["UNBONDING"] = 2] = "UNBONDING";
    /**
     * @generated from enum value: BONDING_STATE_ENUM_UNBONDED = 3;
     */
    BondingState_BondingStateEnum[BondingState_BondingStateEnum["UNBONDED"] = 3] = "UNBONDED";
})(BondingState_BondingStateEnum || (BondingState_BondingStateEnum = {}));
// Retrieve enum metadata with: proto3.getEnumType(BondingState_BondingStateEnum)
proto3.util.setEnumType(BondingState_BondingStateEnum, "penumbra.core.component.stake.v1.BondingState.BondingStateEnum", [
    { no: 0, name: "BONDING_STATE_ENUM_UNSPECIFIED" },
    { no: 1, name: "BONDING_STATE_ENUM_BONDED" },
    { no: 2, name: "BONDING_STATE_ENUM_UNBONDING" },
    { no: 3, name: "BONDING_STATE_ENUM_UNBONDED" },
]);
/**
 * Describes the state of a validator
 *
 * @generated from message penumbra.core.component.stake.v1.ValidatorState
 */
export class ValidatorState extends Message {
    /**
     * @generated from field: penumbra.core.component.stake.v1.ValidatorState.ValidatorStateEnum state = 1;
     */
    state = ValidatorState_ValidatorStateEnum.UNSPECIFIED;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.ValidatorState";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "state", kind: "enum", T: proto3.getEnumType(ValidatorState_ValidatorStateEnum) },
    ]);
    static fromBinary(bytes, options) {
        return new ValidatorState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatorState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatorState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatorState, a, b);
    }
}
/**
 * @generated from enum penumbra.core.component.stake.v1.ValidatorState.ValidatorStateEnum
 */
export var ValidatorState_ValidatorStateEnum;
(function (ValidatorState_ValidatorStateEnum) {
    /**
     * @generated from enum value: VALIDATOR_STATE_ENUM_UNSPECIFIED = 0;
     */
    ValidatorState_ValidatorStateEnum[ValidatorState_ValidatorStateEnum["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: VALIDATOR_STATE_ENUM_DEFINED = 1;
     */
    ValidatorState_ValidatorStateEnum[ValidatorState_ValidatorStateEnum["DEFINED"] = 1] = "DEFINED";
    /**
     * @generated from enum value: VALIDATOR_STATE_ENUM_INACTIVE = 2;
     */
    ValidatorState_ValidatorStateEnum[ValidatorState_ValidatorStateEnum["INACTIVE"] = 2] = "INACTIVE";
    /**
     * @generated from enum value: VALIDATOR_STATE_ENUM_ACTIVE = 3;
     */
    ValidatorState_ValidatorStateEnum[ValidatorState_ValidatorStateEnum["ACTIVE"] = 3] = "ACTIVE";
    /**
     * @generated from enum value: VALIDATOR_STATE_ENUM_JAILED = 4;
     */
    ValidatorState_ValidatorStateEnum[ValidatorState_ValidatorStateEnum["JAILED"] = 4] = "JAILED";
    /**
     * @generated from enum value: VALIDATOR_STATE_ENUM_TOMBSTONED = 5;
     */
    ValidatorState_ValidatorStateEnum[ValidatorState_ValidatorStateEnum["TOMBSTONED"] = 5] = "TOMBSTONED";
    /**
     * @generated from enum value: VALIDATOR_STATE_ENUM_DISABLED = 6;
     */
    ValidatorState_ValidatorStateEnum[ValidatorState_ValidatorStateEnum["DISABLED"] = 6] = "DISABLED";
})(ValidatorState_ValidatorStateEnum || (ValidatorState_ValidatorStateEnum = {}));
// Retrieve enum metadata with: proto3.getEnumType(ValidatorState_ValidatorStateEnum)
proto3.util.setEnumType(ValidatorState_ValidatorStateEnum, "penumbra.core.component.stake.v1.ValidatorState.ValidatorStateEnum", [
    { no: 0, name: "VALIDATOR_STATE_ENUM_UNSPECIFIED" },
    { no: 1, name: "VALIDATOR_STATE_ENUM_DEFINED" },
    { no: 2, name: "VALIDATOR_STATE_ENUM_INACTIVE" },
    { no: 3, name: "VALIDATOR_STATE_ENUM_ACTIVE" },
    { no: 4, name: "VALIDATOR_STATE_ENUM_JAILED" },
    { no: 5, name: "VALIDATOR_STATE_ENUM_TOMBSTONED" },
    { no: 6, name: "VALIDATOR_STATE_ENUM_DISABLED" },
]);
/**
 * Combines all validator info into a single packet.
 *
 * @generated from message penumbra.core.component.stake.v1.ValidatorInfo
 */
export class ValidatorInfo extends Message {
    /**
     * @generated from field: penumbra.core.component.stake.v1.Validator validator = 1;
     */
    validator;
    /**
     * @generated from field: penumbra.core.component.stake.v1.ValidatorStatus status = 2;
     */
    status;
    /**
     * @generated from field: penumbra.core.component.stake.v1.RateData rate_data = 3;
     */
    rateData;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.ValidatorInfo";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator", kind: "message", T: Validator },
        { no: 2, name: "status", kind: "message", T: ValidatorStatus },
        { no: 3, name: "rate_data", kind: "message", T: RateData },
    ]);
    static fromBinary(bytes, options) {
        return new ValidatorInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatorInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatorInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatorInfo, a, b);
    }
}
/**
 * A transaction action (re)defining a validator.
 *
 * @generated from message penumbra.core.component.stake.v1.ValidatorDefinition
 */
export class ValidatorDefinition extends Message {
    /**
     * The configuration data for the validator.
     *
     * @generated from field: penumbra.core.component.stake.v1.Validator validator = 1;
     */
    validator;
    /**
     * A signature by the validator's identity key over the validator data.
     *
     * @generated from field: bytes auth_sig = 2;
     */
    authSig = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.ValidatorDefinition";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator", kind: "message", T: Validator },
        { no: 2, name: "auth_sig", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new ValidatorDefinition().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatorDefinition().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatorDefinition().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatorDefinition, a, b);
    }
}
/**
 * A transaction action adding stake to a validator's delegation pool.
 *
 * @generated from message penumbra.core.component.stake.v1.Delegate
 */
export class Delegate extends Message {
    /**
     * The identity key of the validator to delegate to.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey validator_identity = 1;
     */
    validatorIdentity;
    /**
     * The index of the epoch in which this delegation was performed.
     * The delegation takes effect in the next epoch.
     *
     * @generated from field: uint64 epoch_index = 2;
     */
    epochIndex = protoInt64.zero;
    /**
     * The delegation amount, in units of unbonded stake.
     * TODO: use flow aggregation to hide this, replacing it with bytes amount_ciphertext;
     *
     * @generated from field: penumbra.core.num.v1.Amount unbonded_amount = 3;
     */
    unbondedAmount;
    /**
     * The amount of delegation tokens produced by this action.
     *
     * This is implied by the validator's exchange rate in the specified epoch
     * (and should be checked in transaction validation!), but including it allows
     * stateless verification that the transaction is internally consistent.
     *
     * @generated from field: penumbra.core.num.v1.Amount delegation_amount = 4;
     */
    delegationAmount;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.Delegate";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator_identity", kind: "message", T: IdentityKey },
        { no: 2, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "unbonded_amount", kind: "message", T: Amount },
        { no: 4, name: "delegation_amount", kind: "message", T: Amount },
    ]);
    static fromBinary(bytes, options) {
        return new Delegate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Delegate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Delegate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Delegate, a, b);
    }
}
/**
 * A transaction action withdrawing stake from a validator's delegation pool.
 *
 * @generated from message penumbra.core.component.stake.v1.Undelegate
 */
export class Undelegate extends Message {
    /**
     * The identity key of the validator to undelegate from.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey validator_identity = 1;
     */
    validatorIdentity;
    /**
     * The index of the epoch in which this undelegation was performed.
     *
     * @generated from field: uint64 start_epoch_index = 2 [deprecated = true];
     * @deprecated
     */
    startEpochIndex = protoInt64.zero;
    /**
     * The amount to undelegate, in units of unbonding tokens.
     *
     * @generated from field: penumbra.core.num.v1.Amount unbonded_amount = 3;
     */
    unbondedAmount;
    /**
     * The amount of delegation tokens consumed by this action.
     *
     * This is implied by the validator's exchange rate in the specified epoch
     * (and should be checked in transaction validation!), but including it allows
     * stateless verification that the transaction is internally consistent.
     *
     * @generated from field: penumbra.core.num.v1.Amount delegation_amount = 4;
     */
    delegationAmount;
    /**
     * The epoch in which this delegation was performed.
     *
     * @generated from field: penumbra.core.component.sct.v1.Epoch from_epoch = 5;
     */
    fromEpoch;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.Undelegate";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator_identity", kind: "message", T: IdentityKey },
        { no: 2, name: "start_epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "unbonded_amount", kind: "message", T: Amount },
        { no: 4, name: "delegation_amount", kind: "message", T: Amount },
        { no: 5, name: "from_epoch", kind: "message", T: Epoch },
    ]);
    static fromBinary(bytes, options) {
        return new Undelegate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Undelegate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Undelegate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Undelegate, a, b);
    }
}
/**
 * A transaction action finishing an undelegation, converting (slashable)
 * "unbonding tokens" to (unslashable) staking tokens.
 *
 * @generated from message penumbra.core.component.stake.v1.UndelegateClaim
 */
export class UndelegateClaim extends Message {
    /**
     * @generated from field: penumbra.core.component.stake.v1.UndelegateClaimBody body = 1;
     */
    body;
    /**
     * @generated from field: bytes proof = 2;
     */
    proof = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.UndelegateClaim";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "body", kind: "message", T: UndelegateClaimBody },
        { no: 2, name: "proof", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new UndelegateClaim().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UndelegateClaim().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UndelegateClaim().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UndelegateClaim, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.UndelegateClaimBody
 */
export class UndelegateClaimBody extends Message {
    /**
     * The identity key of the validator to finish undelegating from.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey validator_identity = 1;
     */
    validatorIdentity;
    /**
     * The epoch in which unbonding began, used to verify the penalty.
     *
     * @generated from field: uint64 start_epoch_index = 2 [deprecated = true];
     * @deprecated
     */
    startEpochIndex = protoInt64.zero;
    /**
     * The penalty applied to undelegation, in bps^2 (10e-8).
     * In the happy path (no slashing), this is 0.
     *
     * @generated from field: penumbra.core.component.stake.v1.Penalty penalty = 3;
     */
    penalty;
    /**
     * The action's contribution to the transaction's value balance.
     *
     * @generated from field: penumbra.core.asset.v1.BalanceCommitment balance_commitment = 4;
     */
    balanceCommitment;
    /**
     * / The starting height of the epoch during which unbonding began.
     *
     * @generated from field: uint64 unbonding_start_height = 5;
     */
    unbondingStartHeight = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.UndelegateClaimBody";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator_identity", kind: "message", T: IdentityKey },
        { no: 2, name: "start_epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "penalty", kind: "message", T: Penalty },
        { no: 4, name: "balance_commitment", kind: "message", T: BalanceCommitment },
        { no: 5, name: "unbonding_start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new UndelegateClaimBody().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UndelegateClaimBody().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UndelegateClaimBody().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UndelegateClaimBody, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.UndelegateClaimPlan
 */
export class UndelegateClaimPlan extends Message {
    /**
     * The identity key of the validator to finish undelegating from.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey validator_identity = 1;
     */
    validatorIdentity;
    /**
     * The epoch in which unbonding began, used to verify the penalty.
     *
     * @generated from field: uint64 start_epoch_index = 2 [deprecated = true];
     * @deprecated
     */
    startEpochIndex = protoInt64.zero;
    /**
     * The penalty applied to undelegation, in bps^2 (10e-8).
     * In the happy path (no slashing), this is 0.
     *
     * @generated from field: penumbra.core.component.stake.v1.Penalty penalty = 4;
     */
    penalty;
    /**
     * The amount of unbonding tokens to claim.
     * This is a bare number because its denom is determined by the preceding data.
     *
     * @generated from field: penumbra.core.num.v1.Amount unbonding_amount = 5;
     */
    unbondingAmount;
    /**
     * The blinding factor to use for the balance commitment.
     *
     * @generated from field: bytes balance_blinding = 6;
     */
    balanceBlinding = new Uint8Array(0);
    /**
     * The first blinding factor to use for the ZK undelegate claim proof.
     *
     * @generated from field: bytes proof_blinding_r = 7;
     */
    proofBlindingR = new Uint8Array(0);
    /**
     * The second blinding factor to use for the ZK undelegate claim proof.
     *
     * @generated from field: bytes proof_blinding_s = 8;
     */
    proofBlindingS = new Uint8Array(0);
    /**
     * The height during which unbonding began.
     *
     * @generated from field: uint64 unbonding_start_height = 9;
     */
    unbondingStartHeight = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.UndelegateClaimPlan";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator_identity", kind: "message", T: IdentityKey },
        { no: 2, name: "start_epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "penalty", kind: "message", T: Penalty },
        { no: 5, name: "unbonding_amount", kind: "message", T: Amount },
        { no: 6, name: "balance_blinding", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 7, name: "proof_blinding_r", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 8, name: "proof_blinding_s", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 9, name: "unbonding_start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new UndelegateClaimPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UndelegateClaimPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UndelegateClaimPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UndelegateClaimPlan, a, b);
    }
}
/**
 * A list of pending delegations and undelegations.
 *
 * @generated from message penumbra.core.component.stake.v1.DelegationChanges
 */
export class DelegationChanges extends Message {
    /**
     * @generated from field: repeated penumbra.core.component.stake.v1.Delegate delegations = 1;
     */
    delegations = [];
    /**
     * @generated from field: repeated penumbra.core.component.stake.v1.Undelegate undelegations = 2;
     */
    undelegations = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.DelegationChanges";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "delegations", kind: "message", T: Delegate, repeated: true },
        { no: 2, name: "undelegations", kind: "message", T: Undelegate, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new DelegationChanges().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DelegationChanges().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DelegationChanges().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DelegationChanges, a, b);
    }
}
/**
 * Track's a validator's uptime.
 *
 * @generated from message penumbra.core.component.stake.v1.Uptime
 */
export class Uptime extends Message {
    /**
     * @generated from field: uint64 as_of_block_height = 1;
     */
    asOfBlockHeight = protoInt64.zero;
    /**
     * @generated from field: uint32 window_len = 2;
     */
    windowLen = 0;
    /**
     * @generated from field: bytes bitvec = 3;
     */
    bitvec = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.Uptime";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "as_of_block_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "window_len", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
        { no: 3, name: "bitvec", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new Uptime().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Uptime().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Uptime().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Uptime, a, b);
    }
}
/**
 * Tracks our view of Tendermint's view of the validator set, so we can keep it
 * from getting confused.
 *
 * @generated from message penumbra.core.component.stake.v1.CurrentConsensusKeys
 */
export class CurrentConsensusKeys extends Message {
    /**
     * @generated from field: repeated penumbra.core.keys.v1.ConsensusKey consensus_keys = 1;
     */
    consensusKeys = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.CurrentConsensusKeys";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "consensus_keys", kind: "message", T: ConsensusKey, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new CurrentConsensusKeys().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CurrentConsensusKeys().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CurrentConsensusKeys().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CurrentConsensusKeys, a, b);
    }
}
/**
 * Tracks slashing penalties applied to a validator in some epoch.
 *
 * @generated from message penumbra.core.component.stake.v1.Penalty
 */
export class Penalty extends Message {
    /**
     * @generated from field: bytes inner = 1;
     */
    inner = new Uint8Array(0);
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.Penalty";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    ]);
    static fromBinary(bytes, options) {
        return new Penalty().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Penalty().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Penalty().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Penalty, a, b);
    }
}
/**
 * Requests information about a specific validator.
 *
 * @generated from message penumbra.core.component.stake.v1.GetValidatorInfoRequest
 */
export class GetValidatorInfoRequest extends Message {
    /**
     * The identity key of the validator.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 2;
     */
    identityKey;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.GetValidatorInfoRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "identity_key", kind: "message", T: IdentityKey },
    ]);
    static fromBinary(bytes, options) {
        return new GetValidatorInfoRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetValidatorInfoRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetValidatorInfoRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetValidatorInfoRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.GetValidatorInfoResponse
 */
export class GetValidatorInfoResponse extends Message {
    /**
     * @generated from field: penumbra.core.component.stake.v1.ValidatorInfo validator_info = 1;
     */
    validatorInfo;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.GetValidatorInfoResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator_info", kind: "message", T: ValidatorInfo },
    ]);
    static fromBinary(bytes, options) {
        return new GetValidatorInfoResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetValidatorInfoResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetValidatorInfoResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetValidatorInfoResponse, a, b);
    }
}
/**
 * Requests information on the chain's validators.
 *
 * @generated from message penumbra.core.component.stake.v1.ValidatorInfoRequest
 */
export class ValidatorInfoRequest extends Message {
    /**
     * Whether or not to return inactive validators
     *
     * @generated from field: bool show_inactive = 2;
     */
    showInactive = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.ValidatorInfoRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "show_inactive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new ValidatorInfoRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatorInfoRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatorInfoRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatorInfoRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.ValidatorInfoResponse
 */
export class ValidatorInfoResponse extends Message {
    /**
     * @generated from field: penumbra.core.component.stake.v1.ValidatorInfo validator_info = 1;
     */
    validatorInfo;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.ValidatorInfoResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator_info", kind: "message", T: ValidatorInfo },
    ]);
    static fromBinary(bytes, options) {
        return new ValidatorInfoResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatorInfoResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatorInfoResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatorInfoResponse, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.ValidatorStatusRequest
 */
export class ValidatorStatusRequest extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 2;
     */
    identityKey;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.ValidatorStatusRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "identity_key", kind: "message", T: IdentityKey },
    ]);
    static fromBinary(bytes, options) {
        return new ValidatorStatusRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatorStatusRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatorStatusRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatorStatusRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.ValidatorStatusResponse
 */
export class ValidatorStatusResponse extends Message {
    /**
     * @generated from field: penumbra.core.component.stake.v1.ValidatorStatus status = 1;
     */
    status;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.ValidatorStatusResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "status", kind: "message", T: ValidatorStatus },
    ]);
    static fromBinary(bytes, options) {
        return new ValidatorStatusResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatorStatusResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatorStatusResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatorStatusResponse, a, b);
    }
}
/**
 * Requests the compounded penalty for a validator over a range of epochs.
 *
 * @generated from message penumbra.core.component.stake.v1.ValidatorPenaltyRequest
 */
export class ValidatorPenaltyRequest extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 2;
     */
    identityKey;
    /**
     * @generated from field: uint64 start_epoch_index = 3;
     */
    startEpochIndex = protoInt64.zero;
    /**
     * @generated from field: uint64 end_epoch_index = 4;
     */
    endEpochIndex = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.ValidatorPenaltyRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "identity_key", kind: "message", T: IdentityKey },
        { no: 3, name: "start_epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "end_epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new ValidatorPenaltyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatorPenaltyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatorPenaltyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatorPenaltyRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.ValidatorPenaltyResponse
 */
export class ValidatorPenaltyResponse extends Message {
    /**
     * @generated from field: penumbra.core.component.stake.v1.Penalty penalty = 1;
     */
    penalty;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.ValidatorPenaltyResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "penalty", kind: "message", T: Penalty },
    ]);
    static fromBinary(bytes, options) {
        return new ValidatorPenaltyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatorPenaltyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatorPenaltyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatorPenaltyResponse, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.CurrentValidatorRateRequest
 */
export class CurrentValidatorRateRequest extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 2;
     */
    identityKey;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.CurrentValidatorRateRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "identity_key", kind: "message", T: IdentityKey },
    ]);
    static fromBinary(bytes, options) {
        return new CurrentValidatorRateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CurrentValidatorRateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CurrentValidatorRateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CurrentValidatorRateRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.CurrentValidatorRateResponse
 */
export class CurrentValidatorRateResponse extends Message {
    /**
     * @generated from field: penumbra.core.component.stake.v1.RateData data = 1;
     */
    data;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.CurrentValidatorRateResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "data", kind: "message", T: RateData },
    ]);
    static fromBinary(bytes, options) {
        return new CurrentValidatorRateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CurrentValidatorRateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CurrentValidatorRateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CurrentValidatorRateResponse, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.ValidatorUptimeRequest
 */
export class ValidatorUptimeRequest extends Message {
    /**
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 2;
     */
    identityKey;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.ValidatorUptimeRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "identity_key", kind: "message", T: IdentityKey },
    ]);
    static fromBinary(bytes, options) {
        return new ValidatorUptimeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatorUptimeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatorUptimeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatorUptimeRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.ValidatorUptimeResponse
 */
export class ValidatorUptimeResponse extends Message {
    /**
     * @generated from field: penumbra.core.component.stake.v1.Uptime uptime = 1;
     */
    uptime;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.ValidatorUptimeResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "uptime", kind: "message", T: Uptime },
    ]);
    static fromBinary(bytes, options) {
        return new ValidatorUptimeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ValidatorUptimeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ValidatorUptimeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ValidatorUptimeResponse, a, b);
    }
}
/**
 * Staking configuration data.
 *
 * @generated from message penumbra.core.component.stake.v1.StakeParameters
 */
export class StakeParameters extends Message {
    /**
     * The number of epochs an unbonding note for before being released.
     *
     * @generated from field: uint64 unbonding_epochs = 1 [deprecated = true];
     * @deprecated
     */
    unbondingEpochs = protoInt64.zero;
    /**
     * The maximum number of validators in the consensus set.
     *
     * @generated from field: uint64 active_validator_limit = 2;
     */
    activeValidatorLimit = protoInt64.zero;
    /**
     * The base reward rate, expressed in basis points of basis points
     *
     * @generated from field: uint64 base_reward_rate = 3 [deprecated = true];
     * @deprecated
     */
    baseRewardRate = protoInt64.zero;
    /**
     * The penalty for slashing due to misbehavior.
     *
     * @generated from field: uint64 slashing_penalty_misbehavior = 4;
     */
    slashingPenaltyMisbehavior = protoInt64.zero;
    /**
     * The penalty for slashing due to downtime.
     *
     * @generated from field: uint64 slashing_penalty_downtime = 5;
     */
    slashingPenaltyDowntime = protoInt64.zero;
    /**
     * The number of blocks in the window to check for downtime.
     *
     * @generated from field: uint64 signed_blocks_window_len = 6;
     */
    signedBlocksWindowLen = protoInt64.zero;
    /**
     * The maximum number of blocks in the window each validator can miss signing without slashing.
     *
     * @generated from field: uint64 missed_blocks_maximum = 7;
     */
    missedBlocksMaximum = protoInt64.zero;
    /**
     * The minimum amount of stake required for a validator to be indexed by the protocol.
     *
     * @generated from field: penumbra.core.num.v1.Amount min_validator_stake = 8;
     */
    minValidatorStake;
    /**
     * The number of blocks that must elapse before an unbonding note can be claimed.
     *
     * @generated from field: uint64 unbonding_delay = 9;
     */
    unbondingDelay = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.StakeParameters";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "unbonding_epochs", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "active_validator_limit", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "base_reward_rate", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "slashing_penalty_misbehavior", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 5, name: "slashing_penalty_downtime", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 6, name: "signed_blocks_window_len", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 7, name: "missed_blocks_maximum", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 8, name: "min_validator_stake", kind: "message", T: Amount },
        { no: 9, name: "unbonding_delay", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new StakeParameters().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StakeParameters().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StakeParameters().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StakeParameters, a, b);
    }
}
/**
 * Genesis data for the staking component.
 *
 * @generated from message penumbra.core.component.stake.v1.GenesisContent
 */
export class GenesisContent extends Message {
    /**
     * The configuration parameters for the staking component present at genesis
     *
     * @generated from field: penumbra.core.component.stake.v1.StakeParameters stake_params = 1;
     */
    stakeParams;
    /**
     * The list of validators present at genesis.
     *
     * @generated from field: repeated penumbra.core.component.stake.v1.Validator validators = 2;
     */
    validators = [];
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.GenesisContent";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "stake_params", kind: "message", T: StakeParameters },
        { no: 2, name: "validators", kind: "message", T: Validator, repeated: true },
    ]);
    static fromBinary(bytes, options) {
        return new GenesisContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenesisContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenesisContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenesisContent, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.EventTombstoneValidator
 */
export class EventTombstoneValidator extends Message {
    /**
     * The height at which the offense occurred.
     *
     * @generated from field: uint64 evidence_height = 1;
     */
    evidenceHeight = protoInt64.zero;
    /**
     * The height at which the evidence was processed.
     *
     * @generated from field: uint64 current_height = 2;
     */
    currentHeight = protoInt64.zero;
    /**
     * The validator identity key.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 4;
     */
    identityKey;
    /**
     * The validator's Comet address.
     *
     * @generated from field: bytes address = 5;
     */
    address = new Uint8Array(0);
    /**
     * The voting power for the validator.
     *
     * @generated from field: uint64 voting_power = 6;
     */
    votingPower = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.EventTombstoneValidator";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "evidence_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "current_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "identity_key", kind: "message", T: IdentityKey },
        { no: 5, name: "address", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
        { no: 6, name: "voting_power", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new EventTombstoneValidator().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventTombstoneValidator().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventTombstoneValidator().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventTombstoneValidator, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.EventValidatorStateChange
 */
export class EventValidatorStateChange extends Message {
    /**
     * The validator's identity key.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 1;
     */
    identityKey;
    /**
     * The new state of the validator.
     *
     * @generated from field: penumbra.core.component.stake.v1.ValidatorState state = 2;
     */
    state;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.EventValidatorStateChange";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
        { no: 2, name: "state", kind: "message", T: ValidatorState },
    ]);
    static fromBinary(bytes, options) {
        return new EventValidatorStateChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventValidatorStateChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventValidatorStateChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventValidatorStateChange, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.EventValidatorVotingPowerChange
 */
export class EventValidatorVotingPowerChange extends Message {
    /**
     * The validator's identity key.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 1;
     */
    identityKey;
    /**
     * The new voting power of the validator.
     *
     * @generated from field: penumbra.core.num.v1.Amount voting_power = 2;
     */
    votingPower;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.EventValidatorVotingPowerChange";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
        { no: 2, name: "voting_power", kind: "message", T: Amount },
    ]);
    static fromBinary(bytes, options) {
        return new EventValidatorVotingPowerChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventValidatorVotingPowerChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventValidatorVotingPowerChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventValidatorVotingPowerChange, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.EventValidatorBondingStateChange
 */
export class EventValidatorBondingStateChange extends Message {
    /**
     * The validator's identity key.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 1;
     */
    identityKey;
    /**
     * The new bonding state of the validator.
     *
     * @generated from field: penumbra.core.component.stake.v1.BondingState bonding_state = 2;
     */
    bondingState;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.EventValidatorBondingStateChange";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
        { no: 2, name: "bonding_state", kind: "message", T: BondingState },
    ]);
    static fromBinary(bytes, options) {
        return new EventValidatorBondingStateChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventValidatorBondingStateChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventValidatorBondingStateChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventValidatorBondingStateChange, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.EventRateDataChange
 */
export class EventRateDataChange extends Message {
    /**
     * The validator's identity key.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 1;
     */
    identityKey;
    /**
     * The new rate data.
     *
     * @generated from field: penumbra.core.component.stake.v1.RateData rate_data = 2;
     */
    rateData;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.EventRateDataChange";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
        { no: 2, name: "rate_data", kind: "message", T: RateData },
    ]);
    static fromBinary(bytes, options) {
        return new EventRateDataChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventRateDataChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventRateDataChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventRateDataChange, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.EventValidatorDefinitionUpload
 */
export class EventValidatorDefinitionUpload extends Message {
    /**
     * The validator definition.
     *
     * @generated from field: penumbra.core.component.stake.v1.Validator validator = 1;
     */
    validator;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.EventValidatorDefinitionUpload";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "validator", kind: "message", T: Validator },
    ]);
    static fromBinary(bytes, options) {
        return new EventValidatorDefinitionUpload().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventValidatorDefinitionUpload().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventValidatorDefinitionUpload().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventValidatorDefinitionUpload, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.EventValidatorMissedBlock
 */
export class EventValidatorMissedBlock extends Message {
    /**
     * The validator's identity key.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 1;
     */
    identityKey;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.EventValidatorMissedBlock";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
    ]);
    static fromBinary(bytes, options) {
        return new EventValidatorMissedBlock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventValidatorMissedBlock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventValidatorMissedBlock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventValidatorMissedBlock, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.EventDelegate
 */
export class EventDelegate extends Message {
    /**
     * The validator's identity key.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 1;
     */
    identityKey;
    /**
     * The amount of stake delegated, in the staking token.
     *
     * @generated from field: penumbra.core.num.v1.Amount amount = 3;
     */
    amount;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.EventDelegate";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
        { no: 3, name: "amount", kind: "message", T: Amount },
    ]);
    static fromBinary(bytes, options) {
        return new EventDelegate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventDelegate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventDelegate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventDelegate, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.stake.v1.EventUndelegate
 */
export class EventUndelegate extends Message {
    /**
     * The validator's identity key.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 1;
     */
    identityKey;
    /**
     * The amount of stake undelegated, in the staking token.
     *
     * @generated from field: penumbra.core.num.v1.Amount amount = 3;
     */
    amount;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.EventUndelegate";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
        { no: 3, name: "amount", kind: "message", T: Amount },
    ]);
    static fromBinary(bytes, options) {
        return new EventUndelegate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventUndelegate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventUndelegate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventUndelegate, a, b);
    }
}
/**
 * Indicates a slashing penalty was applied to a validator's reward rates.
 *
 * @generated from message penumbra.core.component.stake.v1.EventSlashingPenaltyApplied
 */
export class EventSlashingPenaltyApplied extends Message {
    /**
     * The validator's identity key.
     *
     * @generated from field: penumbra.core.keys.v1.IdentityKey identity_key = 1;
     */
    identityKey;
    /**
     * The epoch in which the penalty was applied.
     *
     * @generated from field: uint64 epoch_index = 2;
     */
    epochIndex = protoInt64.zero;
    /**
     * The penalty amount after slashing.
     *
     * @generated from field: penumbra.core.component.stake.v1.Penalty new_penalty = 3;
     */
    newPenalty;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.stake.v1.EventSlashingPenaltyApplied";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "identity_key", kind: "message", T: IdentityKey },
        { no: 2, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "new_penalty", kind: "message", T: Penalty },
    ]);
    static fromBinary(bytes, options) {
        return new EventSlashingPenaltyApplied().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventSlashingPenaltyApplied().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventSlashingPenaltyApplied().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EventSlashingPenaltyApplied, a, b);
    }
}
